import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import axiosInstance from "axiosConfig";

export type VatDataType = {
  nip: string;
  nipPrefix: string;
  userUuid?: string;
};

export const useStoreVat = (
  options?: UseMutationOptions<any, Error, VatDataType>
) => {
  return useMutation({
    mutationKey: ["updateVat"],
    mutationFn: async (values: VatDataType) => {
      return axiosInstance
        .put("vat", values)
        .then((res) => res.data);
    },
    onMutate: (variables) => {
      if (options?.onMutate) {
        return options.onMutate(variables);
      }
    },
    onSuccess: (data, variables, context) => {
      if (options?.onSuccess) {
        options.onSuccess(data, variables, context);
      }
    },
    onError: (error, variables, context) => {
      if (options?.onError) {
        options.onError(error, variables, context);
      }
    },
  });
};
